import { render, staticRenderFns } from "./SafeAccount.vue?vue&type=template&id=87b4a5ce&"
import script from "./SafeAccount.vue?vue&type=script&lang=js&"
export * from "./SafeAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports